export const emailRegexp =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const usPostalCodeRegexp = /^\d{5}(?:-\d{4})?$/;
export const caPostalCodeRegexp =
  /^(?:[ABCEGHJ-NPRSTVXY]\d[A-Z][ ]?\d[A-Z]\d)$/i;
export const auAndNzPostalCodeRegexp = /^[0-9]{4}$/;
export const gbPostalCodeRegexp =
  /^([A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2}|GIR ?0A{2})$/;
export const prPostalCodeRegexp = /^[a-zA-Z0-9]{5,9}$/;

export const usAndCaPhoneRegexp =
  /^(?:\+1)?\s?\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/;
export const auPhoneRegexp = /^\d{8,10}$/;
export const gbPhoneRegexp = /^\d{9,11}$/;

export const accountCreditDescriptionRegexp = /^([a-zA-Z0-9-?:().,'+/ ]+)$/;
